import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface GenericDropdownFieldProps {
    label: string;
    register: UseFormRegisterReturn;
    options: { value: string; label: string }[];
    value?: string;
    error?: string;
    disabled?: boolean;
    id?: string;
    placeholder?: string;
    className?: string;
    inputClassName?: string;
}

const GenericDropdownField = ({
    label,
    register,
    options,
    value,
    error,
    disabled = false,
    id,
    placeholder = "Select",
    className = "w-[176px] tablet:w-[190px]",
    inputClassName = "",
}: GenericDropdownFieldProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        // Call the register's onChange first
        if (register.onChange) {
            register.onChange(e);
        }
        // Trigger validation immediately when a value is selected
        if (register.onBlur) {
            register.onBlur({ target: { name: register.name, value: e.target.value } } as any);
        }
    };

    return (
        <div className={`form-control flex-1 ${className}`}>
            <label className="label min-h-7" htmlFor={id}>
                <span className="text-base-content">{label}</span>
            </label>
            <select
                {...register}
                onChange={handleChange}
                id={id}
                value={value || ""}
                className={`select select-bordered bg-base-100 h-9 min-h-9 text-sm ${
                    disabled ? "opacity-50 cursor-not-allowed" : ""
                } ${error ? "select-error" : ""} ${!value ? "text-gray-400" : ""} ${inputClassName}`}
                disabled={disabled}
            >
                <option value="" disabled>
                    {placeholder}
                </option>
                {options.map((option) => (
                    <option key={option.value} value={option.value} className="text-base-content">
                        {option.label}
                    </option>
                ))}
            </select>
            {error && <p className="text-error text-xs mt-1">{error}</p>}
        </div>
    );
};

export default GenericDropdownField;
